const fields = [
    'CislaKrizujicichKomunikaci',
    'CisloBodu',
    'CisloETahu',
    'CisloUzlu',
    'DatumRekultivace',
    'DatumVkladu',
    'DatumZmeny',
    'Dimenze',
    'DruhDopravyLanoveDrahy',
    'DruhLetiste',
    'DruhMelioracnichOpatreni',
    'DruhPlotu',
    'DruhSchodiste',
    'DruhStaniceElektrickeSite',
    'DruhStokoveSite',
    'ElektrizaceZeleznicniTrate',
    'EvidencniCisloObjektu',
    'HraniceJinehoObjektu',
    'ICME',
    'ICS',
    'ID',
    'IDEditora',
    'IDExterni',
    'IDObjektuDrazniStavby',
    'IDObjektuLetiste',
    'IDObjektuSilnicniStavby',
    'IDObjektuStavbyProVodniDopravu',
    'IDProvozovatele',
    'IDProvozovateleZeZakona',
    'IDSpravce',
    'IDVlastnika',
    'IDZmeny',
    'InstalovanyVykon',
    'IzolaceVenkovnihoVedeni',
    'Kapacita',
    'KategoriePozemniKomunikace',
    'KategorieZeleznicniTrate',
    'KritickaTI',
    'Material',
    'MaterialTrasySiteEK',
    'MaximalniNapetovaHladina',
    'MaximalniProvozniNapeti',
    'NazevSledovaneVodniCesty',
    'NeuplnaData',
    'OchrannaFunkce',
    'OznaceniCyklostezky',
    'OznaceniHeliportu',
    'OznaceniKomunikace',
    'OznaceniKomunikaceTrate',
    'OznaceniLetiste',
    'OznaceniObjektu',
    'OznaceniTrate',
    'PocetJizdnichPruhu',
    'PocetKoleji',
    'PocetVedeniVTrase',
    'PopisObjektu',
    'PovoleniNakladaniNebezpecnymOdpadem',
    'PrevazujiciPovrch',
    'ProvozniNapeti',
    'PrujezdnaSirka',
    'PrujezdnaVyska',
    'RokGeodetickehoPorizeni',
    'RokVystavby',
    'RozchodKoleji',
    'StavObjektu',
    'StavSkladkyOdpadu',
    'StavTrasySiteTI',
    'TlakovaHladinaPlynovodniSite',
    'TridaDopravneVyznamneVodniCesty',
    'TridaPresnostiPoloha',
    'TridaPresnostiVyska',
    'TypDopravneVyznamnehoMistaDraze',
    'TypDopravniStavbyNeboPlochy',
    'TypDrahy',
    'TypDrobneKulturniStavby',
    'TypDrobneSakralniStavby',
    'TypInzenyrskeSite',
    'TypInzenyrskeSitePKO',
    'TypJadernehoZarizeni',
    'TypJinehoZarizeniStavebTI',
    'TypLeteckeStavby',
    'TypMediaVodovodniSite',
    'TypMostu',
    'TypNabijecihoVydejnihoMedia',
    'TypNadrzeBezVzdouvacihoObjektu',
    'TypNadrzeZdrzeSeVzdouvacimObjektem',
    'TypNosiceTechnickehoZarizeni',
    'TypOPDrazniStavby',
    'TypOPLeteckychZabezpecovacichZarizeni',
    'TypOPLetiste',
    'TypOPPozemniKomunikace',
    'TypOPSiteEK',
    'TypOPSiteProduktovodu',
    'TypOPZarizeniOdpadovehoHospodarstvi',
    'TypObjektuElektrickeSiteZameru',
    'TypObjektuOdpadovehoHospodarstviZameru',
    'TypObjektuOdvodneniStavby',
    'TypObjektuPlynovodniSiteZameru',
    'TypObjektuSilnicniDopravyZameru',
    'TypObjektuStokoveSite',
    'TypObjektuStokoveSiteZameru',
    'TypObjektuVodovodniSite',
    'TypObjektuVodovodniSiteZameru',
    'TypObjektuZarizeniOchranaPredPovodnemi',
    'TypOdpadu',
    'TypOstatniPlochy',
    'TypPKO',
    'TypPodpernehoZarizeni',
    'TypPodzemnihoZasobnikuPlynu',
    'TypPovrchovehoZnakuTI',
    'TypPovrchuVzletovePristavaciDrahy',
    'TypPozemniKomunikace',
    'TypPrirodnihoPoloprirodnihoObjektu',
    'TypPristavu',
    'TypPrivadece',
    'TypProtipovodnoveZabrany',
    'TypSdilenehoObjektuTI',
    'TypSledovaneVodniCesty',
    'TypSloupu',
    'TypStaniceElektrickeSite',
    'TypStavby',
    'TypSvodidla',
    'TypTechnickehoKanalu',
    'TypTechnologickehoObjektuPlynovodniSite',
    'TypTechnologickehoObjektuSiteEK',
    'TypTechnologickehoObjektuTeplovodniSite',
    'TypTeplovodniSite',
    'TypTerenniHrany',
    'TypTrasyElektrickeSite',
    'TypTrasyMistniElektrickeSite',
    'TypTrasyStokoveSite',
    'TypTrasyTeplovodniSite',
    'TypTrasyVodovodniSite',
    'TypTunelu',
    'TypUdrzovaneZelene',
    'TypUsekuPozemniKomunikace',
    'TypUsekuZeleznicniTrate',
    'TypUzlu',
    'TypVodnihoDila',
    'TypVrtu',
    'TypVyrobnyElektriny',
    'TypZarizeniElektrickeSite',
    'TypZarizeniKanalizacniPripojky',
    'TypZarizeniOdstranovaniOdpadu',
    'TypZarizeniPlynovodniSite',
    'TypZarizeniPotrubniPosty',
    'TypZarizeniPrivadece',
    'TypZarizeniProLeteckyProvoz',
    'TypZarizeniSiteEK',
    'TypZarizeniSiteProduktovodu',
    'TypZarizeniTeplovodniSite',
    'TypZarizeniVodovodniPripojky',
    'TypZdi',
    'TypZeleznicniTrate',
    'TypZemedelskePlochy',
    'UceloveZarazeniStokoveSite',
    'UmisteniHeliportu',
    'UmisteniObjektu',
    'UrovenUmisteniObjektuDI',
    'UrovenUmisteniObjektuTI',
    'UrovenUmisteniObjektuZPS',
    'VedeniSiteVJineStavbe',
    'VkladOsoba',
    'VyskaNaTerenu',
    'ZarazeniSledovaneVodniCesty',
    'ZmenaOsoba',
    'ZpusobOchranyVedeniSiteEK',
    'ZpusobPorizeniDI',
    'ZpusobPorizeniPB_ZPS',
    'ZpusobPorizeniTI',
    'ZpusobPorizeniZPS',
    'ZpusobRekultivace',
];
// MUTATION
export const dmxVariables = fields.reduce((acc, value) => {
    acc += `$${value}: auto,`;
    return acc;
}, '');
export const dmxInputFields = fields.reduce((acc, value) => {
    acc += `${value}: $${value},`;
    return acc;
}, '');
// QUERY
export const dmxFields = fields.reduce((acc, value) => {
    acc += `${value}
  `;
    return acc;
}, '');
//# sourceMappingURL=dmxGqlChunks.js.map